const cards = [
  {
    title: '韩漫精选 · 浪漫恋爱',
    desc: '高甜恋爱韩漫合集，从校园到职场，细腻画风描绘心动瞬间，每一部都让你少女心爆棚。',
    tags: ['韩漫', '恋爱', '高甜'],
    img: 'https://readdy.ai/api/search-image?query=A%20soft%20romantic%20manga%20illustration%20with%20warm%20pink%20and%20peach%20tones%2C%20a%20couple%20under%20cherry%20blossom%20trees%2C%20gentle%20watercolor%20style%2C%20dreamy%20atmosphere%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20aesthetic%2C%20soft%20lighting%2C%20editorial%20quality&width=800&height=560&seq=card-manga-01&orientation=landscape',
  },
  {
    title: '日漫经典 · 热血冒险',
    desc: '燃到爆炸的少年热血日漫，友情、努力、胜利的永恒主题，经典长篇与新生佳作一网打尽。',
    tags: ['日漫', '热血', '冒险'],
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20manga%20illustration%20with%20warm%20orange%20and%20gold%20tones%2C%20a%20heroic%20character%20in%20motion%2C%20energy%20effects%20bursting%2C%20Japanese%20shonen%20style%2C%20bold%20lines%2C%20dramatic%20composition%2C%20clean%20warm%20background%2C%20high%20detail%2C%20editorial%20quality&width=800&height=560&seq=card-manga-02&orientation=landscape',
  },
  {
    title: '国漫崛起 · 奇幻异世界',
    desc: '国产漫画精品推荐，从古风仙侠到现代奇幻，国漫画师用精湛笔触构建惊艳的想象世界。',
    tags: ['国漫', '奇幻', '仙侠'],
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20fantasy%20illustration%20with%20warm%20jade%20green%20and%20gold%20tones%2C%20ancient%20Chinese%20palace%20floating%20in%20clouds%2C%20flowing%20robes%2C%20ethereal%20atmosphere%2C%20ink%20wash%20painting%20influence%2C%20clean%20warm%20background%2C%20high%20detail%2C%20editorial%20quality&width=800&height=560&seq=card-manga-03&orientation=landscape',
  },
  {
    title: '悬疑推理 · 烧脑神作',
    desc: '扣人心弦的悬疑推理漫画，层层反转、步步惊心，考验你的观察力与逻辑推理能力。',
    tags: ['悬疑', '推理', '烧脑'],
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20manga%20illustration%20with%20warm%20sepia%20and%20deep%20brown%20tones%2C%20a%20detective%20silhouette%20against%20a%20dimly%20lit%20alley%2C%20subtle%20clues%20scattered%2C%20noir%20atmosphere%2C%20clean%20composition%2C%20dramatic%20lighting%2C%20editorial%20quality&width=800&height=560&seq=card-manga-04&orientation=landscape',
  },
  {
    title: '搞笑日常 · 解压必备',
    desc: '轻松搞笑的日常系漫画，萌趣画风搭配爆笑剧情，工作学习之余的快乐源泉，减压治愈之选。',
    tags: ['搞笑', '日常', '治愈'],
    img: 'https://readdy.ai/api/search-image?query=A%20cute%20and%20funny%20manga%20illustration%20with%20warm%20yellow%20and%20cream%20tones%2C%20chibi%20characters%20in%20hilarious%20situations%2C%20bright%20cheerful%20atmosphere%2C%20simple%20clean%20background%2C%20slice%20of%20life%20style%2C%20playful%20composition%2C%20editorial%20quality&width=800&height=560&seq=card-manga-05&orientation=landscape',
  },
  {
    title: '新番速递 · 追更日历',
    desc: '每周更新最全的连载漫画追更日历，韩漫周更、日漫月刊、国漫不定期，不错过任何一话更新。',
    tags: ['新番', '连载', '追更'],
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20calendar%20style%20illustration%20with%20warm%20coral%20and%20cream%20tones%2C%20manga%20panels%20arranged%20like%20a%20weekly%20schedule%2C%20colorful%20bookmarks%2C%20organized%20clean%20layout%2C%20editorial%20aesthetic%2C%20soft%20shadows%2C%20high%20detail&width=800&height=560&seq=card-manga-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            精选推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            热门漫画分类精选
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={`樱花漫画 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                  {card.tags.map((tag) => (
                    <span key={tag} className="px-2 py-0.5 rounded-md bg-background-50/90 text-xs font-medium text-foreground-700 backdrop-blur-sm">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-1.5">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}